export var filterMessage = function filterMessage(filter) {
  return function (onMessage) {
    return function (m) {
      if (filter(m)) {
        onMessage(m);
      }
    };
  };
};